import { QueryFunctionContext, QueryKey, QueryMeta } from "@tanstack/react-query";

import { queryClient } from "../queryClient";

export interface SimplifiedQuery {
	queryKey: QueryKey;
	queryFn: (context: QueryFunctionContext) => Promise<any>;
	meta?: QueryMeta;
}

// Utility function to fetch or retrieve multiple queries
export const dataLoader = async (queryStages: Array<Array<() => SimplifiedQuery>>) => {
	for (let stage = 0; stage < queryStages.length - 1; stage++) {
		const queries = queryStages[stage].map((queryFunc) => {
			const query = queryFunc();

			return queryClient.ensureQueryData({
				queryKey: query.queryKey,
				queryFn: query.queryFn,
			});
		});

		await Promise.all(queries);
	}

	const lastQueryStage = queryStages[queryStages.length - 1];
	const promises = lastQueryStage.map((queryFunc) => {
		const query = queryFunc();

		return queryClient.ensureQueryData({
			queryKey: query.queryKey,
			queryFn: query.queryFn,
		});
	});

	return Promise.all(promises);
};
